<template>
  <GmapMap
    ref="mapRef"
    :center="mapCenter"
    :zoom="10"
    :options="mapConfig"
  >
    <GmapMarker
      :key="index"
      v-for="(m, index) in markers"
      :position="m.position"
      :icon="m.icon"
      :label="m.label"
      :zIndex="m.zIndex"
      :optimized="false"
    />

</GmapMap>
</template>

<script>
import { mapSettings } from "@/common/constants/mapSettings";
import { gmapApi } from 'gmap-vue';

export default {
  props: {
    markers: null,
    path: null,
    zoom: 9,
    options: null,

  },

  data() {
    return { }
  },

  computed: {
    google: gmapApi,

    mapConfig() {
      return {
        ...mapSettings,
        center: this.mapCenter
      };
    },
    mapCenter() {
      return this.markers[0].position;
    }
  },

mounted () {

      this.$refs.mapRef.$mapPromise.then((map) => {
        let bounds = new google.maps.LatLngBounds();
        this.markers.forEach((x) => {
          bounds.extend(x.position);
          map.fitBounds(bounds);
        });

        map.fitBounds(bounds);
      })
    }
};
</script>



// WEBPACK FOOTER //
// src/components/tracking-widget/WidgetMap.vue